import React, { useCallback, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Pause, Play } from 'components/icons';
import * as css from './HeroVideo.module.scss';

// Assets
import videoBg from 'components/Homepage/assets/video_bg.jpg';
import VideoMp4 from 'components/Homepage/assets/video.mp4';

export function HeroVideo() {
    // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isVideoPaused, setIsPaused] = useState<boolean>(true);
    const toggleVideo = useCallback(
        (state: boolean) => {
            const $ = videoRef.current;
            if (!$) return;

            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            state ? $.play() : $.pause();
            setIsPaused(state);
        },
        [videoRef],
    );

    return (
        <section className={css.root} style={{ backgroundImage: `url(${videoBg})` }}>
            <video
                loop
                muted
                playsInline
                ref={videoRef}
                // Only show when loaded
                style={{ opacity: 0 }}
                onLoadedData={e => {
                    toggleVideo(true);
                    (e.target as HTMLVideoElement).style.opacity = '1';
                }}
            >
                <source src={VideoMp4} type="video/mp4" />
            </video>

            <div className={css.overlay}>
                <button onClick={() => toggleVideo(!isVideoPaused)} children={isVideoPaused ? <Pause /> : <Play />} />
                <div className={css.text}>
                    <div
                        className={css.title}
                        children={<FormattedMessage id="homepageVideoTitle" defaultMessage="Braiins Academy" />}
                    />
                    <div
                        className={css.claim}
                        children={
                            <FormattedMessage
                                id="homepageVideoClaim"
                                defaultMessage="Everything you need to know about Braiins bitcoin mining solutions"
                            />
                        }
                    />
                </div>
            </div>
        </section>
    );
}
